document.addEventListener('DOMContentLoaded', function() {

  // ============ STICKY HEADER (JS-based, garantiert funktionierend) ============
  (function() {
    const stickyHeader = document.querySelector('sticky-header');
    if (!stickyHeader) return;

    const initialTop = stickyHeader.getBoundingClientRect().top + window.scrollY;
    let spacer = null;

    function ensureSpacer() {
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = 'sticky-header-spacer';
        spacer.style.display = 'none';
        stickyHeader.parentNode.insertBefore(spacer, stickyHeader.nextSibling);
      }
    }

    function onScroll() {
      const scrollY = window.scrollY;
      if (scrollY >= initialTop) {
        if (!stickyHeader.classList.contains('is-fixed')) {
          ensureSpacer();
          const headerHeight = stickyHeader.offsetHeight;
          spacer.style.height = headerHeight + 'px';
          spacer.style.display = 'block';
          stickyHeader.classList.add('is-fixed');
        }
      } else {
        if (stickyHeader.classList.contains('is-fixed')) {
          stickyHeader.classList.remove('is-fixed');
          if (spacer) spacer.style.display = 'none';
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  // ============ MOBILE MENU ============
  const mobileToggle = document.querySelector('.mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => mobileMenu.classList.add('open'));
  }
  if (mobileMenuClose && mobileMenu) {
    mobileMenuClose.addEventListener('click', () => mobileMenu.classList.remove('open'));
  }

  // ============ PRODUCT PAGE: SIZE VARIANTS ============
  document.querySelectorAll('.size-buttons').forEach(group => {
    group.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        group.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
        this.classList.add('selected');
        const optionIndex = group.dataset.optionIndex;
        const label = document.querySelector('[data-option-' + optionIndex + ']');
        if (label) label.textContent = this.dataset.value;
        updateMasterVariant();
      });
    });
  });

  function updateMasterVariant() {
    const productForm = document.querySelector('[data-product-form]');
    if (!productForm) return;
    const variantsJson = document.querySelector('[data-variants-json]');
    if (!variantsJson) return;
    const variants = JSON.parse(variantsJson.textContent);
    const selectedOptions = [];
    document.querySelectorAll('.size-buttons').forEach(group => {
      const selected = group.querySelector('.size-btn.selected');
      if (selected) selectedOptions.push(selected.dataset.value);
    });
    const match = variants.find(v => JSON.stringify(v.options) === JSON.stringify(selectedOptions));
    const idInput = productForm.querySelector('input[name="id"]');
    const submitBtn = productForm.querySelector('.add-to-cart');
    const stockStatus = document.querySelector('.stock-status');
    if (match) {
      if (idInput) idInput.value = match.id;
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        if (match.available) {
          submitBtn.innerHTML = submitBtn.dataset.labelAvailable + ' — ' + formatMoney(match.price);
        } else {
          submitBtn.innerHTML = submitBtn.dataset.labelSoldOut;
        }
      }
      if (stockStatus) {
        if (match.available) {
          stockStatus.classList.remove('out-of-stock');
          stockStatus.innerHTML = '<span class="stock-dot"></span> Auf Lager';
        } else {
          stockStatus.classList.add('out-of-stock');
          stockStatus.innerHTML = '<span class="stock-dot"></span> Ausverkauft';
        }
      }
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }

  // ============ CART DRAWER ============
  const cartDrawer = document.getElementById('cartDrawer');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    document.body.classList.add('cart-drawer-open');
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    document.body.classList.remove('cart-drawer-open');
  }

  // Cart icon click → open drawer
  document.addEventListener('click', function(e) {
    const opener = e.target.closest('[data-cart-open]');
    if (opener) {
      e.preventDefault();
      openCartDrawer();
      return;
    }
    const closer = e.target.closest('[data-cart-close]');
    if (closer) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }
  });

  // ESC to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) {
      closeCartDrawer();
    }
  });

  // AJAX Add to Cart
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('.add-to-cart');
    const originalContent = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Wird hinzugefügt...';
    }

    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(r => {
      if (!r.ok) throw new Error('Fehler beim Hinzufügen');
      return r.json();
    })
    .then(() => refreshCart())
    .then(() => {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalContent;
      }
      openCartDrawer();
    })
    .catch(err => {
      console.error(err);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalContent;
      }
      alert('Es gab ein Problem. Bitte versuche es erneut.');
    });
  });

  // Quantity change in drawer
  document.addEventListener('click', function(e) {
    const qtyBtn = e.target.closest('[data-cart-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      const key = qtyBtn.dataset.cartQtyChange;
      const direction = parseInt(qtyBtn.dataset.direction);
      const item = qtyBtn.closest('.cart-drawer-item');
      const qtyEl = item.querySelector('.cart-drawer-qty-value');
      const currentQty = parseInt(qtyEl.textContent);
      const newQty = Math.max(0, currentQty + direction);
      updateCartItem(key, newQty);
      return;
    }
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      updateCartItem(removeBtn.dataset.cartRemove, 0);
      return;
    }
  });

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(r => r.json())
    .then(() => refreshCart())
    .catch(err => console.error(err));
  }

  function refreshCart() {
    return Promise.all([
      fetch('/cart.js').then(r => r.json()),
      fetch('/?section_id=cart-drawer-render').then(r => r.text()).catch(() => null)
    ]).then(([cart]) => {
      // Update cart count badge in header
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
      // Re-render drawer body via fetch the cart page and extract drawer
      return fetch(window.location.pathname).then(r => r.text()).then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newBody = doc.querySelector('[data-cart-items]');
        const currentBody = document.querySelector('[data-cart-items]');
        if (newBody && currentBody) currentBody.innerHTML = newBody.innerHTML;

        const newTotal = doc.querySelector('[data-cart-total]');
        const currentTotal = document.querySelector('[data-cart-total]');
        if (newTotal && currentTotal) currentTotal.textContent = newTotal.textContent;

        const footer = document.querySelector('[data-cart-footer]');
        if (footer) footer.style.display = cart.item_count > 0 ? '' : 'none';
      });
    });
  }

});
